module.exports = __webpack_public_path__ + "media/react/assets/ReviewInfoCard-7fe2d7607ba501c419b4760545247309.svg";